import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#41d9d7',
      light: '#4ceff2',
      dark: '#0a7e7c',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#fd8917',
      light: '#fee767',
      contrastText: '#ffffff'
    },
    success: {
      main: '#bcfe67',
      contrastText: '#13161e'
    },
    info: {
      main: '#68f5fd',
      contrastText: '#13161e'
    },
    warning: {
      main: '#fee767',
      contrastText: '#13161e'
    },
    error: {
      main: '#b84940',
      contrastText: '#ffffff'
    },
    text: {
      primary: '#ffffff',
      secondary: '#4ceff2'
    },
    background: {
      default: '#0a2a3a',
      paper: '#13161e'
    },
    grey: {
      900: '#13161e',
      800: '#1a1f2e',
      700: '#2a3040',
      600: '#3a4050',
      500: '#4a5060',
      400: '#6a7080',
      300: '#8a9090',
      200: '#aab0b0',
      100: '#cad0d0'
    }
  },
  typography: {
    fontFamily: 'Jost, sans-serif',
    fontSize: 16,
    fontWeightLight: 400,
    fontWeightRegular: 700,
    fontWeightMedium: 700,
    fontWeightBold: 800,
    h1: {
      fontSize: '29.6px',
      fontWeight: 800,
      lineHeight: '23.68px',
      textTransform: 'uppercase'
    },
    h2: {
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '32px'
    },
    body1: {
      fontSize: '16px',
      fontWeight: 700
    }
  },
  shape: {
    borderRadius: 4
  }
});

export default theme;